import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { getPasswordValidation, matchValidator } from '@app/shared/components/password-requirements/password-requirements';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { FormStateMatcher } from '@app/shared/matcher/form-state-matcher';
import { ParentStateMatcher } from '@app/shared/matcher/parent-state-matcher';
import { LdapService } from '@app/shared/services/api/ldap.service';
import { AuthService } from '@app/shared/services/auth.service';
import { HeaderFooterVisibilityService } from '@app/shared/services/header-footer-visibility.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';

@Component({
  selector: 'app-reset-password-process',
  templateUrl: './reset-password-process.component.html',
  styleUrls: ['./reset-password-process.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordProcessComponent implements OnInit {
  token: string = '';
  firstName: string = '';
  lastName: string = '';
  resetPasswordProcessForm: FormGroup = this.fb.group({
    passwords: new FormControl(
      {
        newPassword: new FormControl('', [getPasswordValidation]),
        confirmPassword: new FormControl(''),
      },
      [matchValidator]
    ),
  });

  matcher = new ParentStateMatcher();
  formMatcher = new FormStateMatcher();

  constructor(
    public fb: FormBuilder,
    public overlayLoaderService: OverlayLoaderService,
    public authService: AuthService,
    public ldapService: LdapService,
    private route: ActivatedRoute,
    public headerFooterVisibilityService: HeaderFooterVisibilityService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {
    const rawToken = this.route.snapshot.paramMap.get('token') as string;
    const decoded = JSON.parse(atob(rawToken));
    this.token = decoded.token;
    this.firstName = decoded.firstName;
    this.lastName = decoded.lastName;
  }

  save() {
    this.overlayLoaderService.isLoading = true;

    this.ldapService.changePasswordPublic(this.token, this.newPassword?.value).subscribe({
      next: () => {
        this.overlayLoaderService.isLoading = false;
        this.matDialog.open(NotificationDialogComponent, {
          data: {
            descriptionText: 'Passwort erfolgreich geändert.',
            alignment: 'start',
            orientation: 'row',
          },
          panelClass: ['-md'],
        });
        this.authService.login();
      },
      error: () => {
        this.overlayLoaderService.isLoading = false;
        this.matDialog.open(NotificationDialogComponent, {
          data: {
            descriptionText: 'Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten.',
            alignment: 'start',
            orientation: 'row',
          },
          panelClass: ['-md'],
        });
      },
    });
  }

  get passwords() {
    return this.resetPasswordProcessForm.get('passwords');
  }

  get newPassword() {
    return this.resetPasswordProcessForm.get(['passwords', 'newPassword']);
  }

  get confirmPassword() {
    return this.resetPasswordProcessForm.get(['passwords', 'confirmPassword']);
  }
}
